import { resetCampaign } from '../../store/redux-slice';
import { buildCampaignListUrl } from '../../../utils/url-builders';
import { EngageTracker } from '../../../tracking';
import { ENGAGE_CAMPAIGN_BUILDER_CLOSED } from '../../../tracking/events';
var getCurrentStep = function (pathname) {
    if (pathname.includes('/type'))
        return 'type';
    if (pathname.includes('/configuration'))
        return 'configuration';
    if (pathname.includes('/content'))
        return 'content';
    if (pathname.includes('/review'))
        return 'review';
    if (pathname.includes('/view'))
        return 'view';
    return 'unknown';
};
export var closeCampaign = function (params) {
    var currentStep = getCurrentStep(window.location.pathname);
    EngageTracker.getInstance().track(ENGAGE_CAMPAIGN_BUILDER_CLOSED, {
        campaignId: params.campaignId,
        lastStep: currentStep,
    });
    var campaignListRoute = buildCampaignListUrl({
        session: params.session,
    });
    params.navigate(campaignListRoute);
    params.store.dispatch(resetCampaign({ session: params.session }));
};
